import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { ADMIN_GRADIENTS } from './glassTokens';

/**
 * SectionHeader — eyebrow + title + description + right-slot + gradient underline.
 *
 * Props:
 *   eyebrow    string    — small uppercase label above title
 *   title      string    — main heading
 *   description string  — supporting text
 *   action     node     — right-side action buttons
 */
export default function SectionHeader({ eyebrow, title, description, action, sx = {} }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Box display="flex" alignItems="flex-end" justifyContent="space-between" flexWrap="wrap" gap={2}>
        <Box>
          {eyebrow && (
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                fontWeight: 600,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                fontSize: '0.68rem',
                background: ADMIN_GRADIENTS.accentShort,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 0.5,
              }}
            >
              {eyebrow}
            </Typography>
          )}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: isDark ? '#F8FAFC' : '#0F172A',
            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography
              variant="body2"
              sx={{
                color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(15,23,42,0.55)',
                mt: 0.5,
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
        {action && <Box>{action}</Box>}
      </Box>

      {/* Gradient underline */}
      <Box
        sx={{
          mt: 2,
          height: '1px',
          background: isDark
            ? `linear-gradient(90deg, rgba(99,102,241,0.5) 0%, rgba(99,102,241,0.1) 60%, transparent 100%)`
            : `linear-gradient(90deg, rgba(99,102,241,0.3) 0%, rgba(99,102,241,0.05) 60%, transparent 100%)`,
        }}
      />
    </Box>
  );
}
